const TRANSLITERATION_MAP = {
  а: "a",
  б: "b",
  в: "v",
  г: "h",
  ґ: "g",
  д: "d",
  е: "e",
  є: "ye",
  ж: "zh",
  з: "z",
  и: "y",
  і: "i",
  ї: "yi",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "kh",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "shch",
  ь: "",
  ю: "yu",
  я: "ya",

  // Російські символи, якщо вони трапляться у заголовку
  ё: "yo",
  э: "e",
  ъ: "",
  ы: "y",
};

/**
 * Створює ЧПУ зі звичайного тексту.
 *
 * Приклад:
 * "Як вибрати книгу для дитини?"
 * -> "yak-vybraty-knyhu-dlya-dytyny"
 */
export const createBlogSlug = (value = "") => {
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/[’'`ʼ"]/g, "")
    .split("")
    .map((character) => TRANSLITERATION_MAP[character] ?? character)
    .join("")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");
};

/**
 * Дозволяє вставляти:
 *
 * yak-vybraty-knyhu
 * /blog/yak-vybraty-knyhu
 * https://site.com/blog/yak-vybraty-knyhu
 */
export const normalizeBlogSlug = (value = "") => {
  let source = String(value).trim();

  if (!source) {
    return "";
  }

  try {
    if (/^https?:\/\//i.test(source)) {
      source = new URL(source).pathname;
    }
  } catch (error) {
    console.error("Некоректний URL статті:", error);
  }

  source = source.split("?")[0].split("#")[0];

  const pathParts = source.split("/").filter(Boolean);

  if (pathParts.length > 0) {
    source = pathParts[pathParts.length - 1];
  }

  return createBlogSlug(source);
};

/**
 * Для старих статей без поля slug
 * створює ЧПУ із заголовка.
 */
export const getBlogSlug = (article = {}) => {
  return (
    normalizeBlogSlug(article.slug) ||
    createBlogSlug(article.zag) ||
    article.uid ||
    article.id ||
    ""
  );
};

export const getBlogPath = (article = {}) => {
  const slug = getBlogSlug(article);

  return slug ? `/blog/${slug}` : "/blog";
};

/**
 * Якщо дві статті мають однакову назву:
 *
 * nazva-statti
 * nazva-statti-2
 * nazva-statti-3
 */
export const getUniqueBlogSlug = (baseSlug, usedSlugs = new Set()) => {
  if (!usedSlugs.has(baseSlug)) {
    return baseSlug;
  }

  let index = 2;
  let candidate = `${baseSlug}-${index}`;

  while (usedSlugs.has(candidate)) {
    index += 1;
    candidate = `${baseSlug}-${index}`;
  }

  return candidate;
};
